import axiosInstance from 'services/axios/axios';
import { catchAxiosError, then } from 'services/axios/_utility';
import { FORM_INITIAL_VALUES } from './_const';

/**
 * Fetches the saved challenge-response values for the challenge-response page.
 *
 * @returns {Promise<object>} form prepopulation payload.
 */
export const getChallengeResponsePrepopulation = async () => {
	try {
		return axiosInstance
			.get('/api/ChallengeResponse/GetCurrent')
			.then(response =>
				then(response, payload => ({
					...FORM_INITIAL_VALUES,
					challengeQuestion:
						typeof payload?.challengeQuestion === 'string'
							? payload.challengeQuestion.trim()
							: FORM_INITIAL_VALUES.challengeQuestion,
					secretAnswer:
						typeof payload?.secretAnswer === 'string'
							? payload.secretAnswer
							: FORM_INITIAL_VALUES.secretAnswer,
				}))
			);
	} catch (error) {
		throw catchAxiosError(error);
	}
};

/**
 * Submits challenge-response updates using the dedicated challenge-response endpoint.
 *
 * @param {object} payload challenge-response form payload.
 * @returns {Promise<object>} submit payload from API.
 */
export const submitChallengeResponse = async payload => {
	try {
		return axiosInstance
			.post('/api/ChallengeResponse/Submit', payload)
			.then(response => then(response, responsePayload => responsePayload));
	} catch (error) {
		throw catchAxiosError(error);
	}
};